import { buildApiUrl } from '../../../shared_app/utils/buildApiUrl';
var CURRICULUM_API_ROUTES = {
    lessonCards: buildApiUrl("/api/curriculum/lesson_cards/:lessonId"),
    curriculumGrade: buildApiUrl("/api/curriculum/grade_lessons/:gradeName"),
};
var CURRICULUM_ROUTES = {
    Teacher: '/teachers/g/:groupId/curriculum/:gradeName',
    Supervizor: '/administrators/schools/:schoolId/teachers/:teacherId/groups/:groupId/curriculum/:gradeName',
    Anonymous: '/math/:gradeName',
};
export { CURRICULUM_API_ROUTES, CURRICULUM_ROUTES };
